import {Box, Typography} from '@mui/material';
import {useCallback} from 'react';
import {apiPost} from '../../axiosConfig';
import IconBack from '../../asset/icons/icon_back.svg';

type IBackBtn = {
  title: string | null;
  taskId?: number;
  songRequestId?: number;
};

const BackCloseButton = ({taskId, songRequestId}: IBackBtn) => {
  const handleClose = useCallback(() => {
    if (taskId) {
      apiPost(`/v1/task/${taskId}/unassign?_method=PATCH`);
    } else if (songRequestId) {
      apiPost(`/v1/music-review/${songRequestId}/reviewer/task-unlock`);
    }
    window.close();
  }, [songRequestId, taskId]);

  return (
    <Box onClick={handleClose} className='p-2 flex items-center justify-start'>
      <Box className='flex cursor-pointer p-2'>
        <img src={IconBack} className='mr-3' alt='' />
        <Typography component='h6' className='text-white-50 font-bold'>
          Back
        </Typography>
      </Box>
    </Box>
  );
};
export default BackCloseButton;
